import * as Sentry from "@sentry/react";

import config from "../../config";

Sentry.init({
  ...config.sentry,
  enabled: process.env.NODE_ENV !== "development",
  integrations: [new Sentry.Integrations.Breadcrumbs()],
  beforeSend(event, hint) {
    if (typeof hint?.originalException !== "string") {
      const { name } = (hint?.originalException as { name: string }) ?? {
        name: ""
      };

      if (name) {
        event.fingerprint = [`${name}`];
      }
    }

    return event;
  }
});

export default Sentry;
